import BasicLoadable from "@ovrsea/ovrlib/components/Loadable/BasicLoadable";
import LoadingPage from "@ovrsea/ovrlib/pages/LoadingPage";
import * as React from "react";

export const LoadableAtlasRoutes = BasicLoadable({
  loader: () => import("./AtlasRoutes"),
  loading: <LoadingPage />,
});
